import { client } from "@services/config";
import {
  AgencyService,
  AvailableConfigsResponse,
  Credentials,
  Field,
  ListResponse,
  OnboardResponse,
} from "@gen/agency/v1/agency_pb";
import { Sort } from "./common";
import { Direction } from "@gen/tsam/v1/page_pb";

export async function getAvailableConfigs(
  credentials: Credentials,
): Promise<AvailableConfigsResponse> {
  const res = await client(AgencyService).availableConfigs({
    agencyCredentials: credentials,
  });

  return res;
}

export async function onboardAgency({
  credentials,
  configId,
  alias,
}: {
  credentials: Credentials;
  configId: string;
  alias: string;
}): Promise<OnboardResponse> {
  const res = await client(AgencyService).onboard({
    agencyCredentials: credentials,
    configId: configId,
    agencyAlias: alias,
  });
  return res;
}

export async function getAgencies(
  page: number = 1,
  size: number = 10,
  sort?: Sort,
): Promise<ListResponse> {
  let field: Field;
  switch (sort?.field) {
    case "id":
      field = Field.ID;
      break;
    default:
      field = Field.UNSPECIFIED;
      break;
  }

  let direction: Direction;
  switch (sort?.direction) {
    case "asc":
      direction = Direction.ASC;
      break;
    case "desc":
      direction = Direction.DESC;
      break;
    default:
      direction = Direction.UNSPECIFIED;
      break;
  }
  return await client(AgencyService).list({
    page: {
      page,
      size,
    },
    sort: {
      field,
      direction,
    },
  });
}
